/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Wrong_WalletInputs */

const en_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to the wallet you selected for this deposit, then try again.`)
};

const de_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechseln Sie zu der Wallet, die Sie für diese Einzahlung ausgewählt haben, und versuchen Sie es erneut.`)
};

const pt_br2_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troque para a carteira que você selecionou para este depósito e tente novamente.`)
};

const tr_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu para yatırma işlemi için seçtiğiniz cüzdana geçin ve tekrar deneyin.`)
};

const zh_cn2_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请切换到您为本次存入选择的钱包，然后重试。`)
};

const zh_hk2_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請切換至你為今次存入所選的錢包，然後再試一次。`)
};

const ko_kr2_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 입금에 선택한 지갑으로 전환한 후 다시 시도하세요.`)
};

const ru_ru2_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключитесь на кошелёк, выбранный для этого пополнения, и попробуйте снова.`)
};

const es_419_deposit_error_wrong_wallet = /** @type {(inputs: Deposit_Error_Wrong_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia a la billetera que elegiste para este depósito e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Switch to the wallet you selected for this deposit, then try again." |
*
* @param {Deposit_Error_Wrong_WalletInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_wrong_wallet = /** @type {((inputs?: Deposit_Error_Wrong_WalletInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Wrong_WalletInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_wrong_wallet(inputs)
	if (locale === "de") return de_deposit_error_wrong_wallet(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_wrong_wallet(inputs)
	if (locale === "tr") return tr_deposit_error_wrong_wallet(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_wrong_wallet(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_wrong_wallet(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_wrong_wallet(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_wrong_wallet(inputs)
	return es_419_deposit_error_wrong_wallet(inputs)
});